import React, { useState, useEffect } from 'react';
import './App.css';

const App: React.FC = () => {
  const [listening, setListening] = useState(false);
  const [transcript, setTranscript] = useState('');
  const [interimTranscript, setInterimTranscript] = useState('');
  const [recognition, setRecognition] = useState<null | SpeechRecognition>(null);

  useEffect(() => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (SpeechRecognition) {
      const recognitionInstance = new SpeechRecognition();
      recognitionInstance.continuous = true;
      recognitionInstance.interimResults = true;
      recognitionInstance.lang = 'en-US';

      recognitionInstance.onresult = (event: SpeechRecognitionEvent) => {
        let finalTranscript = '';
        let interimTranscript = '';
        for (let i = event.resultIndex; i < event.results.length; i++) {
          const transcriptSegment = event.results[i][0].transcript;
          if (event.results[i].isFinal) {
            finalTranscript += transcriptSegment;
          } else {
            interimTranscript += transcriptSegment;
          }
        }
        setTranscript(prev => prev + finalTranscript);
        setInterimTranscript(interimTranscript);
      };

      recognitionInstance.onend = () => {
        setListening(false);
      };

      setRecognition(recognitionInstance);
    } else {
      alert('Your browser does not support Speech Recognition');
    }
  }, []);

  const startListening = () => {
    if (recognition && !listening) {
      recognition.start();
      setListening(true);
      setTranscript('');
      setInterimTranscript('');
    }
  };

  const stopListening = () => {
    if (recognition && listening) {
      recognition.stop();
      setListening(false);
    }
  };

  return (
    <div className="App">
      <h1>Speech to Text</h1>
      <div>
        <button onClick={startListening} disabled={listening}>
          Start Listening
        </button>
        <button onClick={stopListening} disabled={!listening}>
          Stop Listening
        </button>
      </div>
      <div>
        <h2>Transcript:</h2>
        <p>{transcript}</p>
        <p style={{ color: 'gray' }}>{interimTranscript}</p>
      </div>
    </div>
  );
};

export default App;
